import {
    useMemo
} from 'react';

import {
    useCompany
} from './state.js';

export default function usePrivateDataTitle(baseTitle, companyId, allCompanies, navigateUrlRenderer) {
    const companyName = useCompany(companyId)?.name;
    const titleText = companyName ? `${baseTitle} / ${companyName}` : baseTitle;
    const titleDropdown = useMemo(() => {
        return () => {
            const companyOptions = _.map(allCompanies, (company) => {
                const navigateUrl = navigateUrlRenderer(company.id);
                return {
                    id: company.id,
                    display: company.name,
                    action: () => {
                        RivalIQ.execute('history:navigate', navigateUrl, {
                            trigger: true
                        });
                    }
                };
            });

            // we're using Marionette here because we're updaing the navigation bar, and the navigation bar is still in the old Marionette world
            return new RivalIQ.views.TitleDropdown({
                model: new Backbone.Model(_.extend({
                    name: titleText
                })),
                collection: new Backbone.Collection(companyOptions)
            });
        };
    }, [titleText, allCompanies, navigateUrlRenderer]);

    if (allCompanies.length <= 1) {
        return titleText;
    }
    return titleDropdown;
}
